export enum Roles {
  SUPER_ADMIN = 1,
  MANAGEMENT_SYSTEM = 2,
  OPERATOR_BO = 3,
  TECHNICIAN = 4,
}

export const RoleNames = {
  [Roles.SUPER_ADMIN]: 'SUPERADMIN',
  [Roles.MANAGEMENT_SYSTEM]: 'MANAGEMENT SYSTEM',
  [Roles.OPERATOR_BO]: 'OPERATOR BO',
  [Roles.TECHNICIAN]: 'TECHNICIAN',
};

// What each role is called in the panel (translation keys): the backoffice of a company, the remote technician who
// answers the calls, the field technician who calls from the headset
export const RoleLabelKeys: Record<number, string> = {
  [Roles.SUPER_ADMIN]: 'user_types.superadmin',
  [Roles.MANAGEMENT_SYSTEM]: 'user_types.backoffice',
  [Roles.OPERATOR_BO]: 'user_types.remote',
  [Roles.TECHNICIAN]: 'user_types.field',
};
